  const insuranceRoutes = {
    insurances: "/insurances",
  };

  export default insuranceRoutes;
